export const GENEALOGY_REPORT_LIST_TABLE_HEADERS = [
  "Sr No.",
  "Report Name",
  "Date of Creation",
  "Generated By",
  "Status",
  "Action",
];



export const GENEALOGY_REPORT_HEADERS = [
  "Material Number",
  "Material Description",
  "Product Type",
  "SAP Production Date",
  "Vendor Batch Number",
  "Purchase Document",
  // "Unit Operation",
];
